<template>
  <div class="ConnectionsView">
    <PageHeader title="Połączenia"
                :description-in-modal="true"
                fa-icon="paper-plane"
                @openDescriptionModal="hintModalVisible = !hintModalVisible"
    />
    <ShPageLayout>
      <ConnectionsListFilterAndSearch :connections-filters="connectionsFilters" />
      <div style="margin-bottom: 15px;">
        <ConnectionsUtilsPagination />
      </div>
      <ConnectionsList />
      <div style="margin-top: 15px;">
        <ConnectionsUtilsPagination />
      </div>
    </ShPageLayout>
    <ShSideBarModal title="Szczegóły zdarzeń"
                    :side-bar-modal-visibility.sync="isConnectionDetailsAndActionVisible"
                    :width="1200"
                    class="ConnectionDetailsModal"
    >
      <template v-slot:content>
        <ConnectionDetailsAndNotes :connection="connection" />
      </template>
      <template v-slot:footer>
        <ConnectionAddNote :connection="connection"
                           @closeModal="isConnectionDetailsAndActionVisible = false"
        />
      </template>
    </ShSideBarModal>
    <ShModalWindow v-if="hintModalVisible"
                   @closeModal="hintModalVisible = !hintModalVisible"
    >
      <template #header>
        <img style="margin-right:10px"
             :src="require('@/assets/images/ikona-polaczenia.png')"
        >
        Połączenia
      </template>
      <template #description>
        <PopupHints hint-template-name="connections" />
      </template>
    </ShModalWindow>
  </div>
</template>

<script>
import { PopupHintsUtils } from '@/mixins';
import ShPageLayout from '@/components/Helpers/ShPageLayout';
import ShSideBarModal from '@/components/Helpers/ShSideBarModal';
import ShModalWindow from '@/components/Helpers/ShModalWindow';
import PageHeader from '@/components/Common/PageHeader';
import PopupHints from '@/components/Common/PopupHints';
import ConnectionAddNote from '@/components/Connections/ConnectionDetailsAndNotes/ConnectionAddNote';
import ConnectionDetailsAndNotes from '@/components/Connections/ConnectionDetailsAndNotes';
import ConnectionsUtilsPagination from '@/components/Connections/ConnectionsUtilsPagination';
import ConnectionsListFilterAndSearch from '@/components/Connections/ConnectionsListFilterAndSearch';
import ConnectionsList from '@/components/Connections/ConnectionsList';

export default {
  name: 'ConnectionsView',
  components: {
    PageHeader,
    ShPageLayout,
    ShSideBarModal,
    ShModalWindow,
    PopupHints,
    ConnectionAddNote,
    ConnectionDetailsAndNotes,
    ConnectionsUtilsPagination,
    ConnectionsListFilterAndSearch,
    ConnectionsList,
  },

  mixins: [PopupHintsUtils],

  data() {
    return {
      isConnectionDetailsAndActionVisible: false,
      connection: null,
    };
  },
  computed: {
    connectionsFilters() {
      return this.$store.getters['connections/connectionsFilters'];
    },
  },
  async created() {
    this.mCheckInLocalStorageIfModalHasBeenAlreadyShown('connectionsModalOpen');
    this.$EventBus.$on('ConnectionsListItem/SHOW_DETAILS_AND_ACTIONS', (connection) => {
      this.isConnectionDetailsAndActionVisible = true;
      this.connection = connection;
    });
    this.$EventBus.$on('ConnectionChangeStatus/UPDATE_CONNECTION_RECORD', (updatedConnection) => {
      this.connection = updatedConnection;
    });

    this.$store.dispatch('connections/clearConnetionsDownloadFilter', { andGetConnections: false });
    this.$store.dispatch('agents/getList');
    this.$store.dispatch('departments/getList');
    this.$store.dispatch('widgets/getList');
    await this.$store.dispatch('connections/getNotifyStatuses');
    await this.$store.dispatch('connections/getConnections');
  },
  beforeDestroy() {
    this.$EventBus.$off('ConnectionsListItem/SHOW_DETAILS_AND_ACTIONS');
    this.$EventBus.$off('ConnectionChangeStatus/UPDATE_CONNECTION_RECORD');
  },
};
</script>
